import { render, staticRenderFns } from "./UserManagementSetup.vue?vue&type=template&id=a884cebc&scoped=true"
import script from "./UserManagementSetup.vue?vue&type=script&lang=ts"
export * from "./UserManagementSetup.vue?vue&type=script&lang=ts"
import style0 from "./UserManagementSetup.vue?vue&type=style&index=0&id=a884cebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a884cebc",
  null
  
)

export default component.exports